import styled from "styled-components";
import { hex2rgba } from "../../utils/styles";

export const StyledPagination = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
`;

export const StylesInputPage = styled.input`
    ${({ theme }) => theme.fonts.mulishLight};
    font-size: 14px;
    letter-spacing: -0.025em;
    color: ${({ theme }) => theme.colors.darkGrey};
    text-align: center;
    min-width: 40px;
    flex-basis: 40px;
    border-radius: 5px;
    height: 30px;
    padding: 6px;
    border: none;
    box-shadow: 0px 0px 2px 0px ${({ theme }) => hex2rgba(theme.colors.black, 0.16)};
    outline: none;
    -moz-appearance: textfield;
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;